import React from "react"

import { DownloadLink } from "./DownloadLink"
import { Link, LinkProps } from "./Link"
import { Maybe } from "types/Maybe"

type LinkType = "download" | string

interface OwnProps {
  linkType?: Maybe<LinkType>
}

export type LinkSwitchProps = OwnProps & LinkProps

export const LinkSwitch: React.FC<LinkSwitchProps> = ({
  linkType,
  ...linkProps
}): React.ReactElement => {
  switch (linkType) {
    case "download":
      return <DownloadLink {...linkProps} />
    default:
      return <Link {...linkProps} />
  }
}
